import { Eye, EyeOff } from "lucide-react";

import { ChangeEventHandler, FC, useState } from "react";
import { SMALL_ICON_SIZE_STYLES } from "../../ui/styles";

type InputAttrs = React.InputHTMLAttributes<HTMLInputElement>;

type PasswordInputProps = {
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
};

export const PasswordInput: FC<
  React.PropsWithChildren<PasswordInputProps & InputAttrs>
> = ({ onChange, value, ...args }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <input
        type={showPassword ? "text" : "password"}
        name="password"
        id="password"
        autoComplete="password"
        minLength={8}
        value={value}
        onChange={onChange}
        className="block h-9 w-full rounded-md border-stone-300 px-2 shadow-sm focus:border-stone-500 focus:ring-stone-500 dark:border-stone-800 dark:bg-stone-700 dark:text-white sm:text-sm"
        {...args}
      />

      {value.length > 0 && (
        <span
          className="absolute top-1.5 right-2 z-10 p-1 text-stone-500 dark:text-stone-400"
          role="button"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? (
            <EyeOff className={SMALL_ICON_SIZE_STYLES} />
          ) : (
            <Eye className={SMALL_ICON_SIZE_STYLES} />
          )}
        </span>
      )}
    </div>
  );
};
